import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Pagination } from '../../models/pagination.interface';
import { LibPaginationService } from '../../shared/services/lib-pagination.service';
@Component({
  selector: 'lib-pagination',
  templateUrl: './lib-pagination.component.html',
  styleUrls: ['./lib-pagination.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LibPaginationComponent implements OnChanges {
  @Output() selectedItem: EventEmitter<number> = new EventEmitter();
  @Input() dataLength: number;
  @Input() selectedIndex: number;
  @Input() page: number = 1;
  pager: Pagination;
  constructor(private libPaginationService: LibPaginationService) {}

  ngOnChanges(): void {
    this.paginationOfSelectedItem(this.page);
  }

  paginationOfSelectedItem(page: number): void {
    this.page = page;
    // get pager object from service
    this.pager = this.libPaginationService.getPager(this.dataLength, page);
    // get current page of items
    this.selectedItem.emit(this.page - 1);
  }
}
